import React, { useEffect, useRef, useState } from "react";
import { translate } from "reducers/i18n";
import { FiCornerUpLeft, FiArrowRight, FiArrowLeft } from "react-icons/fi";
import { PdfViewer } from "./pdfViewer/index";
import { DcmViewer } from "./dcmViewer";
import * as XLSX from "xlsx/xlsx.mjs";
import { useExcelDownloder } from "react-xls";
import { XlsxViewer } from "./xlsxViewer";
import { CsvViewer } from "./csvViewer";
import { XmlViewer } from "./xmlViewer";
import { Modal } from "components/modal";
import { TxtViewer } from "./txtViewer";

const viewers = {
  pdf: PdfViewer,
  dcm: DcmViewer,
  xlsx: XlsxViewer,
  csv: CsvViewer,
  xml: XmlViewer,
  txt: TxtViewer,
};

export const AttachmentsViewer = ({
  setShowViewer,
  attachment,
  setAttachment,
  changeDisplayedAttachment,
}) => {
  const [url, setUrl] = useState(null);
  const [padding, setPadding] = useState("20px 15px");
  const [extension, setExtension] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    console.log({ attachment });
    if (attachment) {
      let url = attachment.data;
      const fileExt = attachment.filename.split(".").pop().toLowerCase();
      setUrl(url);
      setExtension(fileExt);
      setPadding(fileExt === "dcm" ? "0" : "20px 15px");
    }
  }, [attachment]);

  const DisplayAttachment = () => {
    if (!attachment) {
      return <p>Loading...</p>;
    }
    const Viewer = viewers[extension];
    const validImageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const isValidImageExtension = validImageExtensions.includes(extension);

    return Viewer ? (
      <Viewer url={attachment.data} handleExpand={() => setShowModal(true)} />
    ) : isValidImageExtension ? (
      <img src={url} alt="Attachment" className="w-100" />
    ) : (
      <p
        className="w-100 align-items-center justify-content-center d-flex"
        style={{ height: "100px" }}
      >
        Unsupported attachment type.
      </p>
    );
  };

  const ModalViewer = () => {
    const Viewer = viewers[extension];
    if (!Viewer || !attachment) return;
    return (
      <Modal
        title={attachment.filename}
        handleClose={() => setShowModal(false)}
      >
        <Viewer url={attachment.data} modal={true} />
      </Modal>
    );
  };

  return (
    <>
      <div
        className="panel mb-3"
        // style={{ minWidth: "fit-content" }}
      >
        <div className="panelHeader header_fontFamily">
          <h1>{attachment?.filename}</h1>
        </div>
        <div
          className="panelContent d-flex flex-column body_fontFamily"
          style={{
            maxHeight: "67vh",
            overflow: "auto",
            justifyContent: "start",
            alignItems: "start",
            padding: padding,
          }}
        >
          <DisplayAttachment />
        </div>
        <div className="panelFooter buttons_fontFamily">
          <div className="messageFooter d-flex justify-content-between">
            <button
              tabIndex="0"
              className="btn btn-secondary text-dark"
              onClick={() => setShowViewer(false)}
            >
              <FiCornerUpLeft className="" /> {translate("_back_to_msg")}
            </button>
            <div className="">
              <button
                tabIndex="0"
                className="button"
                disabled={attachment?.first}
                onClick={() => changeDisplayedAttachment(attachment?.i - 1)}
              >
                <FiArrowLeft className="" />
              </button>
              <button
                tabIndex="0"
                className="button"
                disabled={attachment?.last}
                onClick={() => changeDisplayedAttachment(attachment?.i + 1)}
              >
                <FiArrowRight className="" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <ModalViewer />}
    </>
  );
};
